import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { streamWrite } from "@/components/AiWriter";

export function PostHelp({ text, onText }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    const idea = text.trim() || window.prompt("Worüber möchtest du posten? (ein paar Stichworte)");
    if (!idea || idea.trim().length < 2) return;
    setBusy(true);
    try { await streamWrite({ idea }, (t) => onText(t.replace(/\*\*/g, "").trim().slice(0, 2000)), "/ai/post-help"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={go} disabled={busy} title="Schreibhilfe: aus Stichworten einen Beitrag machen" data-testid="composer-ai-help"
      className="h-9 px-3 rounded-full bg-emerald-50 text-emerald-700 hover:bg-emerald-100 text-xs font-bold flex items-center gap-1.5 disabled:opacity-60 transition-colors">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Schreibhilfe
    </button>
  );
}
